import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }


import BaseImg from './BaseImg.vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/swiper-bundle.css'
import SwiperCore, {
  Navigation,
  Pagination,
  Mousewheel,
  Keyboard
} from 'swiper'


export default /*#__PURE__*/_defineComponent({
  __name: 'VCarousel',
  props: {
    activididadId: null,
    slider: null
  },
  setup(__props: any) {

const props = __props as {
  activididadId?: number
  slider: {
    path: string
    id: string
  }[]
};

SwiperCore.use([Navigation, Pagination, Mousewheel, Keyboard])



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (props.slider.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(Swiper), {
            navigation: true,
            pagination: true,
            keyboard: true,
            class: "mySwiper rounded-3",
            "preload-images": true
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.slider, (img) => {
                return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                  key: img.id
                }, {
                  default: _withCtx(() => [
                    _createVNode(BaseImg, {
                      src: img.path,
                      roundered: false
                    }, null, 8, ["src"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : (props.slider.length === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(BaseImg, {
              "activididad-id": props.activididadId,
              src: props.slider[0].path
            }, null, 8, ["activididad-id", "src"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(BaseImg, {
              "activididad-id": props.activididadId
            }, null, 8, ["activididad-id"])
          ]))
  ]))
}
}

})